export default __webpack_public_path__ + "static/cruiselogo_crystal-38e584a2db429154088aad11ce673979.png";